/**
 * Created by admin on 2017/9/13.
 */
{
    angular.module('interfaceModule')
        .controller('machineTipController',machineTipController)
    machineTipController.$inject = ['$scope',"$state",'$http','$stateParams','utils.constant','alertControl','utils.platform','$timeout','utils.common','requestHandler','ModalWindow','utils.currentUser','request.order'];
    function machineTipController($scope,$state,$http,$stateParams,constant,alertControl,platform,$timeout,common,requestHandler,ModalWindow,currentUser,orderRequest){
        let vm = this;

        let collect = {
            'activate':activate,
            'timer':null,
            'getMachineInfo':getMachineInfo,
            'choseErro':choseErro,
            'terminalInfo':null,
            'printerErroInfo':[],
            'terminalErroInfo':[],

        }
        vm.collect=collect;
        activate();

        function activate() {
            console.log('进入终端机情况页面');
            collect.userid = $stateParams.userId;
            getMachineInfo();
            $scope.$on("$destroy", function(e) {
                console.log(collect.timer);
                $timeout.cancel(collect.timer);

            })
        }
        //获取终端机信息
        function getMachineInfo(){
            collect.terminalInfo = null;
            var _data = [{
                'userid': collect.userid
                //'userid':'15575952384'
            }];
            // console.log('要传的参数', _data);
            let params = "partnermachine=" + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.partnermachineinfo, params,
                function(responce){
                    if(!collect.addActive){
                        $('#tab').find('li').eq(0).addClass('active');
                        collect.addActive = true;
                    }

                    console.log('返回的加盟商终端机信息',responce);
                    if(responce.data[0].result == 1){

                        collect.terminalInfo = responce.data[0].partnermachine;
                        var terminalArr = [];
                        for(var i=0; i<collect.terminalInfo.length; i++){
                            var terminal = {};
                            //判断打印机类型
                            var a = collect.terminalInfo[i].bwprinter + collect.terminalInfo[i].colorprinter;
                            //console.log('a的值',a);
                            switch (a){
                                case '00':
                                    collect.terminalInfo[i].printertype = '';
                                    delete collect.terminalInfo[i].bwprinter;
                                    delete collect.terminalInfo[i].colorprinter;
                                    break;

                                case '01':
                                    collect.terminalInfo[i].printertype = '彩色';
                                    delete collect.terminalInfo[i].bwprinter;
                                    delete collect.terminalInfo[i].colorprinter;
                                    break;

                                case '10':
                                    collect.terminalInfo[i].printertype = '黑白';
                                    delete collect.terminalInfo[i].bwprinter;
                                    delete collect.terminalInfo[i].colorprinter;
                                    break;

                                case '11':
                                    collect.terminalInfo[i].printertype = '黑白/彩色';
                                    delete collect.terminalInfo[i].bwprinter;
                                    delete collect.terminalInfo[i].colorprinter;
                                    break;

                                default:
                                    collect.terminalInfo[i].printertype = '';
                                    delete collect.terminalInfo[i].bwprinter;
                                    delete collect.terminalInfo[i].colorprinter;
                            };

                            //页面尺寸判断：
                            var b = collect.terminalInfo[i].printerpagetype;
                            var c = parseInt(b,2);
                            switch (c){
                                case 0:
                                    collect.terminalInfo[i].printerpagetype = '';
                                    break;

                                case 1:
                                    collect.terminalInfo[i].printerpagetype = 'A4';
                                    break;

                                case 2:
                                    collect.terminalInfo[i].printerpagetype = 'A3';
                                    break;

                                case 3:
                                    collect.terminalInfo[i].printerpagetype = 'A3/A4';
                                    break;

                                default:
                                    collect.terminalInfo[i].printerpagetype = '';
                            }
                        };
                        //console.log('填表的信息', collect.terminalInfo);
                        //collect.printerErroInfo = collect.terminalInfo;       //  ==> BUG:这种赋值方法把两个参数双向绑定了。作用域相同
                        //collect.terminalErroInfo = collect.terminalInfo;

                        // console.log('打印机的信息', printerErroInfo);
                        // console.log('终端机的信息', terminalErroInfo);

                        // angular.copy（）==》只拿数据你，不拿连接地址; 解决了赋值时的双向绑定
                        var printerErroInfo = angular.copy(collect.terminalInfo);
                        var terminalErroInfo =angular.copy( collect.terminalInfo);
                        choseErro(printerErroInfo,terminalErroInfo);

                    }
                },
                function(responce){

                }
            );


        }
        //筛选出错的终端机和打印机
        function choseErro(printerErroInfo,terminalErroInfo){
            //console.log('打印机信息',printerErroInfo);
            //console.log('终端机信息',terminalErroInfo);
            collect.printerErroInfo = [];
            collect.terminalErroInfo = [];
            //筛选出错误的打印机：
            for(var i=0; i<printerErroInfo.length; i++){
                if(printerErroInfo[i].comments.indexOf('normal') == -1){
                    //delete collect.printerErroInfo[i];
                    //printerErroInfo.splice(i,1);
                    //printerErroInfo.remove(printerErroInfo[i]);
                    collect.printerErroInfo.push(printerErroInfo[i]);
                }
            };
            //筛选出错误的终端机机：
            var _hours = new Date().getHours();
            var _min = new Date().getMinutes();
            for(var i=0; i<terminalErroInfo.length; i++){

                if((_hours - terminalErroInfo[i].reporttime.substr(11).substring(0,2) != 0) || (_min - terminalErroInfo[i].reporttime.substr(11).substring(3,5) > 5) || (_min - terminalErroInfo[i].reporttime.substr(11).substring(3,5) < -5)){
                    collect.terminalErroInfo.push(terminalErroInfo[i]);
                }

            };
            //这时才进行赋值
            //collect.printerErroInfo = printerErroInfo;
            //collect.terminalErroInfo = terminalErroInfo;
            console.log('筛选出的打印机',collect.printerErroInfo);
            console.log('筛选出的终端机',collect.terminalErroInfo);
            //console.log('原来的填表信息', collect.terminalInfo);

            if(collect.printerErroInfo.length > 0){
                collect.printerErroNull = true;
            }else{
                collect.printerErroNull = false;
            };

            if(collect.terminalErroInfo.length > 0){
                collect.terminalErroNull = true;
            }else{
                collect.terminalErroNull = false;
            };
            //定时检测；
            collect.timer=$timeout(collect.getMachineInfo,30000);   //==>BUG: 在这里延时器里的函数只能写 collect.getMachineInfo ，不能写 getMachineInfo 或 getMachineInfo()  。

        }
    }
}